"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = noop;
function noop() {}
//# sourceMappingURL=noop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2-utilizr/lib/noop.js
// module id = 148
// module chunks = 13